// Basic
import PropTypes from 'prop-types';
// Components
import TooltipHelper from '../../tooltip/TooltipHelper';
import { Button } from '@/common-utils/components/ui/button';
import Entity from '../../entity/Entity';

/**
 * @param root0
 * @param root0.action
 * @param root0.isMediumDevice
 * @param root0.retractable
 * @param root0.translate
 * @param root0.variant
 * @returns {JSX} RenderSingleAction
 */
function RenderSingleAction({ action, isMediumDevice, retractable, translate, variant }) {
    if (isMediumDevice && retractable) {
        return <TooltipHelper
            asChild
            trigger={
                <Button
                    onClick={action.onClick}
                    disabled={action.disabled}
                    title={action.disabled ? translate(action.tooltipForbidden) : undefined}
                    icon={action.icon}
                    variant={variant}
                    className='h-8 rounded-lg px-2'
                />
            }
            content={
                <Entity
                    entity={action.entity}
                    namespace={action.namespace}
                    nowrap
                />
            }
        />;
    }
    return <Button
        onClick={action.onClick}
        disabled={action.disabled}
        title={action.disabled ? translate(action.tooltipForbidden) : undefined}
        icon={action.icon}
        entity={action.entity}
        namespace={action.namespace}
        variant={variant}
        className='h-8 rounded-lg pl-1 pr-2'
    />;
}

RenderSingleAction.propTypes = {
    action: PropTypes.object,
    isMediumDevice: PropTypes.bool,
    retractable: PropTypes.bool,
    translate: PropTypes.func,
    variant: PropTypes.string
};
export default RenderSingleAction;